import React, { useRef, useState, useContext } from 'react';
import Video from 'components/Layout/Menu/components/Dog/components/Video';
import ExerciseWrapper from 'components/UI/ExerciseWrapper/ExerciseWrapper';
import './VideoExercise.module.scss';
import { HomeworkContext } from 'screens/Homework/Homework';
import ExerciseBottom from 'components/UI/ExerciseBottom/ExerciseBottom';
import ControlBar from 'components/Layout/ControlBar/ControlBar';

export default function VideoExercise({
    exercise,
    setStatus,
}: {
    exercise: ExerciseEntity;
    setStatus: React.Dispatch<React.SetStateAction<exerciseStatusType>>;
}) {
    const [exerciseStatus, setExerciseStatus] = useState<exerciseStatusType>(
        'started'
    );

    const { setProgress } = useContext(HomeworkContext);

    const videoRef = useRef();

    const onVideoEnd = (event) => {
        if (event.type === 'ended') {
            setExerciseStatus('finished');
            setStatus('finished');
            setProgress(1);
        }
    };

    const startVideo = () => {
        videoRef.current?.play();
    };

    return (
        <>
            {exercise?.video_id && (
                <>
                    <ExerciseWrapper>
                        <div styleName="video-wrapper">
                            <Video
                                onEnded={onVideoEnd}
                                videoRef={videoRef}
                                videoId={exercise?.video_id}
                            />
                        </div>
                    </ExerciseWrapper>
                    <ExerciseBottom
                        controlBar={
                            <ControlBar
                                handlePlayClick={startVideo}
                                exerciseStatus={exerciseStatus}
                            />
                        }
                    />
                </>
            )}
        </>
    );
}
